'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../node_modules/prop-types/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var Article = function Article(_ref) {
  var SocialBlock = _ref.SocialBlock,
      title = _ref.title,
      introduction = _ref.introduction,
      body = _ref.body;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "article",
    id: "page-body"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "share-template"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "social"
  }, /*#__PURE__*/React__default['default'].createElement("h5", {
    className: "social-title"
  }, "Share"), SocialBlock)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "featured-content"
  }, /*#__PURE__*/React__default['default'].createElement("div", null, title, introduction), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "content-article"
  }, body)));
};

Article.defaultProps = {};
Article.propTypes = {
  body: index['default'].node,
  introduction: index['default'].node,
  SocialBlock: index['default'].node,
  title: index['default'].node
};
exports.Article = Article;
exports['default'] = Article;